export const listCityAmva = [
    "MEDELLIN",
    "BARBOSA",
    "BELLO",
    "CALDAS",
    "COPACABANA",
    "ENVIGADO",
    "GIRARDOTA",
    "ITAGUI",
    "LA CEJA",
    "LA ESTRELLA",
    "EL RETIRO",
    "RIONEGRO",
    "SABANETA",
];